import { Component, ElementRef, Inject, OnInit, ViewChild } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ErrorList } from '../../../shared-components/controls/error-prompt/error-list.model';
import { Lookup } from '../../../shared-components/lookup/lookup.model';
import { LookupService } from '../../../shared-components/lookup/lookup.service';
import { Attachment } from '../../../shared-components/models/attachment.model';
import { SecurityService } from '../../../shared-components/security/security.service';
import { UserPermission } from '../../../shared-components/user/user-permission.model';

@Component({
  selector: 'add-edit-document',
  templateUrl: './add-edit-document.component.html',
  styleUrls: ['./add-edit-document.component.css']
})
export class AddEditDocumentComponent implements OnInit {

  attachment: Attachment = new Attachment();
  forOptions: string[] = ['Household'];
  errors: ErrorList[] = [];
  V9UserPermissions: UserPermission[] = [];
  maxFileSize = 0;
  v10: boolean;
  quickAdd: boolean;
  edit: boolean;
  actionSectionHidden: boolean;
  documentTypes: Lookup[];
  documentTypeIdAsString: string;
  @ViewChild('attachmentNameRef', { read: ElementRef }) attachmentNameRef: ElementRef;
  @ViewChild('forRef', { read: ElementRef }) forRef: ElementRef;
  @ViewChild('documentTypeRef', { read: ElementRef, static: true }) documentTypeRef: ElementRef;

  constructor(
    private lookupService: LookupService,
    @Inject(MAT_DIALOG_DATA) private data: any,
    private dialogBox: MatDialogRef<AddEditDocumentComponent>,
    private securityService: SecurityService
  ) {
    if (data.attachments.StudentName != null) {
      this.forOptions.push(data.attachments.StudentName);
    }
    // for Household or Student

    if (data.attachments != null) {
      if (data.attachments.DocumentId > 0) {
        this.edit = true;
        this.attachment.DocumentId = data.attachments.DocumentId;
        this.attachment.Description = data.attachments.Notes;
        this.attachment.DocumentType = data.attachments.DocumentFor != 'Family' ? data.attachments.StudentName : 'Household';
        this.attachment.DocumentTypeId = data.attachments.DocumentTypeId;
        this.attachment.FileType = data.attachments.FileType;
        this.documentTypeIdAsString = this.attachment.DocumentTypeId.toString();
      }
      else {
        this.attachment.Description = '';
        this.attachment.OriginalFileName = '';
        this.attachment.MyFileBase64String = '';
        this.attachment.DocumentTypeId = 0;
        this.attachment.DocumentType = data.attachments.StudentName;
      }
    }
  }

  ngOnInit() {
    const permissions = this.securityService.userPermissions;
    this.V9UserPermissions = permissions;



    this.getDocumentTypeLookup();
  }
  getDocumentTypeLookup() {
    this.lookupService.getDocumentTypeLookup().subscribe(document => {
      this.documentTypes = document;
      const blankRow = new Lookup();
      blankRow.Id = '0';
      blankRow.Code = '';
      blankRow.CodeDescription = '';
      this.documentTypes.splice(0, 0, blankRow);
      const checkPermission = this.V9UserPermissions.filter(permission => permission.PermissionCode != 'DSF_MADFSF' &&
        permission.PermissionCode == 'DSF_MDSF');
      if (checkPermission != undefined && checkPermission != null && checkPermission.length) {
        const documentTypes = [];
        for (let i = 0; i < checkPermission.length; i++) {
          this.documentTypes.forEach(obj => {
            const sameIdExist = documentTypes.filter(data => data.Id == obj.Id)[0];
            if (!documentTypes || !documentTypes.length || !sameIdExist) {
              if (obj.PermissionCategory == checkPermission[i].PermissionCategory) {
                documentTypes.push(obj);
              }
            }
          });
        }
        this.documentTypes = [];
        this.documentTypes = documentTypes;
      }
    });
  }

  validate() {
    this.errors = [];
    if (this.attachment.Description == '') {
      this.errors.push({
        fieldRef: this.attachmentNameRef,
        fieldName: 'Description',
        errorMsg: 'Required field.'
      });
    }
    if (this.attachment.OriginalFileName == '') {
      this.errors.push({
        fieldRef: null,
        fieldName: 'File',
        errorMsg: 'Please select a file.'
      });
    }
    if (this.attachment.DocumentTypeId == null || this.attachment.DocumentTypeId == undefined || this.attachment.DocumentTypeId == 0) {
      this.errors.push({
        fieldRef: this.documentTypeRef,
        fieldName: 'Document Type',
        errorMsg: 'Please select a Document Type.'
      });
    }
    if (this.maxFileSize > 0 && this.maxFileSize < (this.attachment.MyFileBase64String.length * 6 / 8) / 1000) {
      this.errors.push({
        fieldRef: null,
        fieldName: 'File',
        errorMsg: 'This file size not allowed. File size should not be greater than ' + this.maxFileSize + 'KB.'
      });
    }
    // Validating file if no other errors are present
    if (this.errors.length == 0 && this.attachment.DocumentTypeId <= 0) {
      const fileExtensionRegExp = /\.[a-z]{3}/;
      if (this.attachment.FileExtension.toLowerCase() != 'pdf' &&
        this.attachment.FileExtension.toLowerCase() != 'jpg' &&
        this.attachment.FileExtension.toLowerCase() != 'png' &&
        this.attachment.FileExtension.toLowerCase() != 'txt' &&
        this.attachment.FileExtension.toLowerCase() != 'doc' &&
        this.attachment.FileExtension.toLowerCase() != 'docx' &&
        this.attachment.FileExtension.toLowerCase() != 'xls' &&
        this.attachment.FileExtension.toLowerCase() != 'xlsx') {
        this.errors.push({
          fieldRef: null,
          fieldName: 'File',
          errorMsg: 'Only .txt, .doc(x), .xls(x), .pdf, .jpg, and .png files can be uploaded.'
        });
      }
    }
  }
  save() {
    this.validate();
    if (this.errors.length == 0) {
      this.dialogBox.close('Save');
    }
  }
  documentTypeChanged() {
    const rp = parseInt(this.documentTypeIdAsString, 10);
    if (!isNaN(rp)) {
      this.attachment.DocumentTypeId = rp;
    }
  }
  close() {
    this.dialogBox.close('Cancel');
  }
}
